export const feedbackTypeColor: {[key: string] : string} = {
  communicatie: 'primary',
  contractafspraken: 'secondary',
  kwaliteit: 'pending',
  nazorg: 'blue-magenta',
  oplevering: 'green-cyan',
  overig: 'orange',
  planning: 'success',
  uitvoeringswijze: 'red-orange',
  veiligheid: 'warning',
};

/**
 * This returns the color based on the key from reportStatusMap
 * @param color
 */
export const getFeedbackTypeColor = (type: string): string => feedbackTypeColor[type];
